// extracted by mini-css-extract-plugin
export default {"table-row":"ApPbq","status-cell":"sqYQM"};